import { render, staticRenderFns } from "./check.vue?vue&type=template&id=a0dfc104&scoped=true&lang=pug"
import script from "./check.vue?vue&type=script&lang=js"
export * from "./check.vue?vue&type=script&lang=js"
import style0 from "./check.vue?vue&type=style&index=0&id=a0dfc104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dfc104",
  null
  
)

export default component.exports